import React from 'react'
import './style.scss';
export default function Policy() {
    return (
        <div id="Policy">
             <div className="banner">
      <h1>Policy</h1>
      <p>Far far away, behind the word mountains, far from the countries Vokalia and Far far away, behind the word
       
        mouConsonantia, there live the blind textsFar far away, behind the word mountains, far from the co
      </p>
    </div>
            <div className="container">
                <ul>
                    <li>
                        <h4>  Information Gathering and Use</h4>
                        <p>We collect information from you in a number of ways, for example when you:

                            Make a donation Sign up to our campaign Sign up to stay updated
                            We won’t collect or record your personal information unless you choose to give it us.</p>
                    </li>

                    <li>
                        <h4>  Use of Personal Information</h4>
                        <p>  We use the information you give us in the following ways:
                            <ul>

                                <li>To make sure we have an accurate record of all the donations we receive. </li>
                                <li>To email you with news and information about CARE India and our campaigns, but only if you have agreed to this.</li>
                                <li>To make sure you are receiving the most appropriate and relevant information for you.</li>
                                <li>To find out more about you and the people who are visiting our website, donating or joining our campaign.</li>
                            </ul>

                        </p>
                    </li>

                    <li>
                        <h4>    Privacy of our email lists</h4>
                        <p>Individuals who join our mailing lists via our website or through our campaigning engagements are added to our email database. We do not sell, rent, loan, trade, or lease the addresses on our lists to anyone.</p>
                    </li>

                    <li>
                        <h4>   Cookie Policy</h4>
                        <p>            Cookies are pieces of electronic information which will be sent by CARE India when you use our web site. These will be placed in your computer’s hard disk and enable us to recognise you as a user when you next visit.
                            You can configure your browser so that it responds to cookies the way you deem fit. For example, you make want to accept all cookies, reject them all or get notified when a cookie is sent. Please check your browser’s settings to modify cookie behaviour as per your individual behaviour.
                            Please note that if you disable the use of cookies on your web browser or remove or reject specific cookies from our website or linked sites then you may not be able to use the website as it is intended.</p>
                    </li>

                    <li>
                        <h4>  Security & Protection of Data</h4>
                        <p>            C

                            CARE India uses well-recognised and proven technology for payments. Payment information is transferred by the use of an SSL connection which offers the highest degree of security that your browser is able to support.
                            Several layers of built-in security, including an advanced firewall system, encryption of credit card numbers, and use of passwords, protect the collected information.</p>
                    </li>

                    <li>
                        <h4>  Changes to Privacy Policy</h4>
                        <p>           As and when the need arises, CARE India may alter its privacy policy in accordance with the latest technology and trends. We strive to provide you with timely notice of these changes. You may reach out to us if you have any queries about any changes made to our practices.</p>
                    </li>
                </ul>





            </div>


        </div>
    )
}
